import React from 'react';
import { resumeUrl, socialLinks } from '../../data/portfolio';

const Hero = () => (
  <section className="hero section" id="home" aria-labelledby="hero-title">
    <div className="shell hero-grid">
      <div className="hero-copy">
        <p className="eyebrow"><span className="status-dot" /> AI ENGINEER · BENGALURU, INDIA</p>
        <h1 id="hero-title">Muhammed<br /><span>Nihas.</span></h1>
        <p className="hero-role">AI Engineer <span>|</span> Agentic AI <span>|</span> LLMs <span>|</span> RAG <span>|</span> Production AI Systems</p>
        <p className="hero-intro">I design and build production AI systems, from multi-agent orchestration and retrieval pipelines to model serving and backend infrastructure. I take them from architecture through deployment with evaluation and reliability in mind.</p>
        <div className="hero-actions">
          <a className="button button-primary" href="#professional-work">View projects <span aria-hidden="true">↗</span></a>
          <a className="button button-outline" href={resumeUrl} download="Muhammed-Nihas-Resume.pdf" data-analytics-event="resume_download">Download resume <span aria-hidden="true">↓</span></a>
        </div>
        <div className="hero-social" aria-label="Professional profiles">
          {socialLinks.map((link) => <a key={link.label} href={link.url} target="_blank" rel="noopener noreferrer">{link.label} <span aria-hidden="true">↗</span></a>)}
        </div>
      </div>
      <div className="system-visual" role="img" aria-label="AI system architecture: user request, agent orchestration, retrieval, tools, inference, and evaluation">
        <div className="system-topline"><span>PRODUCTION AI / SYSTEM VIEW</span><span>01 — 04</span></div>
        <div className="system-node system-input"><span className="node-index">01</span><span>USER REQUEST</span><span className="node-signal">● ● ●</span></div>
        <div className="system-connector" aria-hidden="true" />
        <div className="system-node system-orchestrator"><span className="node-index">02</span><strong>AGENT ORCHESTRATION</strong><small>State · routing · memory</small></div>
        <div className="system-branches" aria-hidden="true"><i /><i /><i /></div>
        <div className="system-three">
          <div className="system-node"><span className="node-index">03a</span><strong>RETRIEVAL</strong><small>Vectors + rerank</small></div>
          <div className="system-node"><span className="node-index">03b</span><strong>TOOLS</strong><small>APIs + actions</small></div>
          <div className="system-node"><span className="node-index">03c</span><strong>INFERENCE</strong><small>Serving + scale</small></div>
        </div>
        <div className="system-connector" aria-hidden="true" />
        <div className="system-node system-output"><span className="node-index">04</span><span>EVALUATION & OBSERVABILITY</span><span className="output-check">✓</span></div>
        <div className="system-footer"><span>DESIGNED FOR RELIABILITY</span><span className="system-pulse">● LIVE SYSTEMS</span></div>
      </div>
    </div>
    <div className="shell hero-bottom"><a href="#about">SCROLL TO EXPLORE <span aria-hidden="true">↓</span></a></div>
  </section>
);

export default Hero;
